// extracted by mini-css-extract-plugin
export default {"buttons":"BusquedaUsuarioView_buttons__aYWpP","form":"BusquedaUsuarioView_form__boGOh","title":"BusquedaUsuarioView_title__1C8mr"};